import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstancefhanbu89c1sm as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketEngine1lh73ie4wh0m5 as WebSocketEngine } from './WebSocketEngine.js.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { GraphQLWsProtocol3nqe2321ot0cb as GraphQLWsProtocol } from './GraphQLWsProtocol.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { awaitClose10k42f6qjplpu as awaitClose } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { WebSocketPool28m608awosr6h as WebSocketPool } from './internal/WebSocketPool.mjs';
import { callbackFlow1g384rkuy0hni as callbackFlow } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { buffer2o7vhreze5nfc as buffer } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { ChannelResult2y4k69ac6y3du as ChannelResult } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import {
  SubscriptionOperationException3t8cqqpx8bt9j as SubscriptionOperationException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Key_getInstance3kkpczi3zr320 as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { jsonReader2agwreccj3lmk as jsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { toApolloResponse9u5mcqg84l2p as toApolloResponse } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function WebSocketNetworkTransport$Builder$build$slambda() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return null;
  }), 0);
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.e65_1 = null;
        this.f65_1 = null;
        this.g65_1 = null;
        this.h65_1 = null;
        this.i65_1 = null;
        this.j65_1 = null;
        this.k65_1 = null;
        this.l65_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
      }
      a65(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.e65_1 = serverUrl;
        return this;
      }
      m65(idleTimeout) {
        // Inline function 'kotlin.apply' call
        this.j65_1 = idleTimeout;
        return this;
      }
      e3a() {
        var tmp0_elvis_lhs = this.f65_1;
        var tmp5_webSocketEngine = tmp0_elvis_lhs == null ? WebSocketEngine() : tmp0_elvis_lhs;
        var tmp6_serverUrl = this.e65_1;
        var tmp1_elvis_lhs = this.j65_1;
        var tmp;
        var tmp_0 = tmp1_elvis_lhs;
        if ((tmp_0 == null ? null : new (Duration())(tmp_0)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp = toDuration(60, DurationUnit_SECONDS_getInstance());
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp7_idleTimeout = tmp;
        var tmp2_elvis_lhs = this.g65_1;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          tmp_1 = new (GraphQLWsProtocol())(WebSocketNetworkTransport$Builder$build$slambda());
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var tmp8_wsProtocol = tmp_1;
        var tmp9_pingInterval = this.i65_1;
        var tmp3_elvis_lhs = this.h65_1;
        var tmp_2;
        var tmp_3 = tmp3_elvis_lhs;
        if ((tmp_3 == null ? null : new (Duration())(tmp_3)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp_2 = toDuration(10, DurationUnit_SECONDS_getInstance());
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        var tmp10_connectionAcknowledgeTimeout = tmp_2;
        var tmp4_elvis_lhs = this.k65_1;
        var tmp11_parserFactory = tmp4_elvis_lhs == null ? new (DefaultSubscriptionParserFactory())(get_impl(this.l65_1)) : tmp4_elvis_lhs;
        return new (WebSocketNetworkTransport())(tmp5_webSocketEngine, tmp6_serverUrl, tmp8_wsProtocol, tmp10_connectionAcknowledgeTimeout, tmp9_pingInterval, tmp7_idleTimeout, tmp11_parserFactory);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
function WebSocketNetworkTransport$execute$slambda($renewUuid, $request, this$0) {
  return constructCallableReference(($this$callbackFlow, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if ($renewUuid._v) {
      tmp = $request.g44().z42(uuid4()).e3a();
    } else {
      tmp = $request;
    }
    var newRequest = tmp;
    $renewUuid._v = true;
    var operationListener = new (DefaultOperationListener())(newRequest, $this$callbackFlow, this$0.r6a_1.t6a($request));
    var webSocket = this$0.s6a_1.c6b(newRequest);
    webSocket.q6b(newRequest, operationListener);
    yield* awaitClose($this$callbackFlow, () => {
      webSocket.r6b(newRequest);
      return Unit_instance;
    }, $completion);
    return Unit_instance;
  }), 1);
}
var WebSocketNetworkTransportClass;
function WebSocketNetworkTransport() {
  if (WebSocketNetworkTransportClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, wsProtocol, connectionAcknowledgeTimeout, pingInterval, idleTimeout, parserFactory) {
        this.l6a_1 = webSocketEngine;
        this.m6a_1 = serverUrl;
        this.n6a_1 = wsProtocol;
        this.o6a_1 = connectionAcknowledgeTimeout;
        this.p6a_1 = pingInterval;
        this.q6a_1 = idleTimeout;
        this.r6a_1 = parserFactory;
        this.s6a_1 = new (WebSocketPool())(this.l6a_1, this.m6a_1, this.n6a_1, this.o6a_1, this.p6a_1, this.q6a_1);
      }
      h66(request) {
        var renewUuid = {_v: false};
        var flow = callbackFlow(WebSocketNetworkTransport$execute$slambda(renewUuid, request, this));
        return buffer(flow, 2147483647);
      }
      n10() {
        this.s6a_1.m6();
      }
    }
    initMetadataForClass($, 'WebSocketNetworkTransport');
    WebSocketNetworkTransportClass = $;
  }
  return WebSocketNetworkTransportClass;
}
function errorResponse($this, cause) {
  return Builder().r44($this.s6b_1.p43_1, $this.s6b_1.q43_1).w44(cause).e3a();
}
var DefaultOperationListenerClass;
function DefaultOperationListener() {
  if (DefaultOperationListenerClass === VOID) {
    class $ {
      constructor(request, producerScope, parser) {
        this.s6b_1 = request;
        this.t6b_1 = producerScope;
        this.u6b_1 = parser;
      }
      v6b(response) {
        var tmp0_safe_receiver = this.u6b_1.w6b(response);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = this.t6b_1.x1b(tmp0_safe_receiver);
          new (ChannelResult())(tmp$ret$0);
        }
      }
      x6b() {
        this.t6b_1.i1c();
      }
      y6b(payload) {
        this.t6b_1.x1b(errorResponse(this, SubscriptionOperationException().n4h(this.s6b_1.p43_1.operationName(), payload)));
        this.t6b_1.i1c();
      }
      z6b(cause) {
        this.t6b_1.x1b(errorResponse(this, cause));
        this.t6b_1.i1c();
      }
    }
    initMetadataForClass($, 'DefaultOperationListener');
    DefaultOperationListenerClass = $;
  }
  return DefaultOperationListenerClass;
}
var DefaultSubscriptionParserFactoryClass;
function DefaultSubscriptionParserFactory() {
  if (DefaultSubscriptionParserFactoryClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl) {
        this.a6c_1 = incrementalDeliveryProtocolImpl;
      }
      t6a(request) {
        return new (DefaultSubscriptionParser())(this.a6c_1, request);
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParserFactory');
    DefaultSubscriptionParserFactoryClass = $;
  }
  return DefaultSubscriptionParserFactoryClass;
}
var DefaultSubscriptionParserClass;
function DefaultSubscriptionParser() {
  if (DefaultSubscriptionParserClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl, request) {
        this.b6c_1 = request;
        this.c6c_1 = incrementalDeliveryProtocolImpl.x67();
        var tmp = this;
        var tmp0_elvis_lhs = this.b6c_1.t43_1.p48(Key_getInstance());
        tmp.d6c_1 = tmp0_elvis_lhs == null ? Key_getInstance().d48_1 : tmp0_elvis_lhs;
      }
      w6b(response) {
        var responseMap = (!(response == null) ? isInterface(response, KtMap()) : false) ? response : null;
        if (responseMap == null) {
          return Builder().r44(this.b6c_1.p43_1, this.b6c_1.q43_1).w44(DefaultApolloException().m45('Invalid payload')).e3a();
        }
        var tmp;
        if (isDeferred(responseMap)) {
          tmp = to(this.c6c_1.j68(responseMap), this.c6c_1.f68());
        } else {
          tmp = to(responseMap, null);
        }
        var _destruct__k2r9zo = tmp;
        var payload = _destruct__k2r9zo.df();
        var deferredFragmentIdentifiers = _destruct__k2r9zo.ef();
        var apolloResponse = toApolloResponse(jsonReader(payload), this.b6c_1.p43_1, this.b6c_1.q43_1, this.d6c_1, deferredFragmentIdentifiers);
        if (!this.c6c_1.g68()) {
          this.c6c_1.a3r();
        }
        var tmp_0;
        if (this.c6c_1.h68()) {
          tmp_0 = null;
        } else {
          tmp_0 = apolloResponse;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParser');
    DefaultSubscriptionParserClass = $;
  }
  return DefaultSubscriptionParserClass;
}
function isDeferred(_this__u8e3s4) {
  return _this__u8e3s4.w4().t2('hasNext');
}
//region block: exports
export {
  Builder_0 as Builder1suvx83rlbrz1,
};
//endregion

//# sourceMappingURL=WebSocketNetworkTransport.mjs.map
